import { NIL as uuidNil } from "uuid";

export default function isNonEmptyGuid(g?: string) {
  if (!g) return false;

  if (g === uuidNil) return false;

  return true;
}
